export default "__VITE_ASSET__DNRzSD79__"